import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Information from './Information';
import l from './Label.css';

function RelevantInnehall() {
  return (
    <Information>
      <p>
        <span className={l.label}>{'Exempel'}</span>
      </p>
      <p>
        {`
          Du vill märka fiskbullar med kostrådet ”Ät mer fisk”. Du bör då
          märka ut mängden fisk genom att skriva t ex ”Innehåller 60 % fisk”.
        `}
      </p>
    </Information>
  );
}

export default withStyles(l)(RelevantInnehall);



// WEBPACK FOOTER //
// ./src/components/Information/RelevantInnehall.js